// /src/toolkitServices/userPermissionApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const userPermissionApi = createApi({
  reducerPath: "userPermissionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include", // cookie based auth
  }),
  tagTypes: ["UserPermission"],
  endpoints: (builder) => ({
    // 🔹 GET: user ke overrides (UserPermission collection se)
    getUserPermissions: builder.query({
      query: (userId) => `/user-permissions/${userId}`,
      providesTags: (_res, _err, userId) => [
        { type: "UserPermission", id: userId },
      ],
    }),

    // 🔹 GET: Employee + Role + User + Effective permissions
    //  -> /api/user-permissions/employee/:employeeId
    getEmployeeEffectivePermissions: builder.query({
      query: (employeeId) => `/user-permissions/employee/${employeeId}`,
      providesTags: (_res, _err, employeeId) => [
        { type: "UserPermission", id: `emp-${employeeId}` },
      ],
    }),

    // 🔹 POST: user ke special permissions set / override
    setUserPermissions: builder.mutation({
      query: ({ userId, permissions }) => ({
        url: `/user-permissions`,
        method: "POST",
        body: { userId, permissions },
      }),
      invalidatesTags: (_res, _err, { userId }) => [
        { type: "UserPermission", id: userId },
        { type: "UserPermission", id: `emp-${userId}` }, // safety
      ],
    }),
  }),
});

export const {
  useGetUserPermissionsQuery,
  useGetEmployeeEffectivePermissionsQuery,
  useSetUserPermissionsMutation,
} = userPermissionApi;

export default userPermissionApi;
